/* eslint-disable no-bitwise */
/* eslint-disable no-param-reassign */

// -------------------------------------------------------------------------
// TODO: Add Tests for all of these
// -------------------------------------------------------------------------

export const getAddRegistration = (state, action) => {
    const registrationToAdd = action.payload;
    const validRegistrations = state.registrations.filter(
        (existingRegistration) => Object.keys(existingRegistration).length > 0,
    );
    const newRegistrations = [...validRegistrations, registrationToAdd];
    const currentRegistration = newRegistrations.length - 1;

    state.currentRegistration = currentRegistration;
    state.registrations = newRegistrations;
};

export const getRemoveRegistration = (state, action) => {
    const index = action.payload;
    const newRegistrations = [
        ...state.registrations.filter((reg, i) => i !== index),
    ];
    const newCurrentRegistration =
        state.currentRegistration >= index
            ? state.currentRegistration - 1
            : state.currentRegistration;

    // This value must also be set back to the now current registrant's category when a registrant is
    // removed or Cancelled to prevent corrupting the state with the previously current Category
    const newCurrentRegistrationCategory =
        newRegistrations[newCurrentRegistration].Category;

    state.currentRegistration = newCurrentRegistration;
    state.currentRegistrationCategory = newCurrentRegistrationCategory;
    state.registrations = newRegistrations;
};

export const getAddItemToRegistrationStoreCart = (state, action) => {
    const newCart = [...state.storeCart, { ...action.payload }];

    state.storeCart = newCart;
};

export const getRemoveRegistrationStoreCartItem = (state, action) => {
    const { index, productId, fieldDataId } = action.payload;

    const storeCart = [
        ...state.storeCart.filter((item, i) => {
            //   Remove when item in cart is changed to produce a duplicate (ids can not be used)
            if (index !== null) {
                return i !== index;
            }
            // Safer remove from remove button
            return (
                item.Product_Id !== productId ||
                item.Field_Data_Id !== fieldDataId
            );
        }),
    ];

    state.storeCart = storeCart;
};

export const getUpdateCategoryOnRegistrations = (state, action) => {
    const { index, Category } = action.payload;
    const { registrations } = state;
    const updateRegistrant = registrations[index];
    updateRegistrant.Category = Category;

    const newRegistrations = registrations.map((registrant, i) => {
        if (i === index) {
            return updateRegistrant;
        }
        return registrant;
    });

    state.registrations = newRegistrations;
    state.currentRegistrationCategory = [];
};

export const getUpdateRegistrationTotals = (state, action) => {
    const { totals } = action.payload;

    const _totals = state.totals;

    const getNewTotals = () => {
        if (Object.keys(totals).length > 0) {
            return {
                ..._totals,
                ...totals,
            };
        }
        return { ..._totals };
    };

    const newTotals = getNewTotals();

    state.totals = { ...newTotals };
};

export const getUpdateRegistrationStoreCart = (state, action) => {
    const { storeCart } = state;
    const { index, productId, fieldDataId } = action.payload;
    const cartItem = action.payload.storeCart;

    // If updating Store Cart from summary or store list view (most common conditions), we use the current index in order to determine
    // which element will get replaced by the new cartItem coming with payload.
    // Race Conditions exception: The payload should receive a null value for index if race conditions trigger the update.
    // The index becomes unreliable when the cart is updated based on a race condition because we are comparing the submitted storeCart
    // with the new image of the available storeCart items from BE and if any of those items were removed when mapped over the index will no
    // longer match up. The qty is all that would be changing, so we can instead use the
    // Product Id and Field Data Id to identify the item needing to be replaced with new cartItem

    const newStoreCart = storeCart.map((_storeItem, i) => {
        if (
            (index !== null && i !== index) ||
            (index === null &&
                (_storeItem.Product_Id !== productId ||
                    _storeItem.Field_Data_Id !== fieldDataId))
        ) {
            return _storeItem;
        }

        return {
            ..._storeItem,
            ...cartItem,
        };
    });

    state.storeCart = [...newStoreCart];
};

export const getUpdateRegistration = (state, action) => {
    const { registrations } = state;
    const { index, registration } = action.payload;

    const newRegistrations = registrations.map((_registration, i) => {
        if (i !== index) {
            return _registration;
        }

        // This block of code is needed to remove a custom field that was previously answered
        // for a category in the event that the user decides to change categories and the custom
        // fields have now changed.  Because we are simply spreading the old and new registration
        // to allow the old to be overwritten by the new values, we need to manually remove the
        // Custom Field keys with value that are no longer relevant.

        const existingCustomFieldKeys = Object.keys(_registration).filter(
            (key) => ~key.indexOf("Custom"),
        );
        const newCustomFieldKeys = Object.keys(registration).filter(
            (key) => ~key.indexOf("Custom"),
        );

        const customFieldKeysToRemove = existingCustomFieldKeys.filter(
            (key) => !newCustomFieldKeys.includes(key),
        );
        if (customFieldKeysToRemove.length > 0) {
            // eslint-disable-next-line no-restricted-syntax
            for (const key of customFieldKeysToRemove) {
                delete _registration[key];
            }
        }

        return {
            ..._registration,
            ...registration,
        };
    });

    state.registrations = [...newRegistrations];
};
